import modal from '@/components/common/modal/modal.vue'
import formButton from '@/components/common/form-button/form-button.vue'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    modal,
    formButton
  },
  data() {
    return {
      timeToExpire: null,
      timer: null
    }
  },
  computed: {
    ...mapState('app', ['timeOfLastRequest']),
    ...mapState('auth', ['sessionExpirationPopupTime', 'sessionExpirationTime'])
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('auth', ['logout']),
    ...mapActions('app', ['getXCsrfToken', 'clearExpirationPopup']),
    getTimeToExpire: function () {
      this.timer = setInterval(
        function () {
          this.timeToExpire =
            Math.ceil((moment(this.timeOfLastRequest) + this.sessionExpirationTime - moment()) / 1000) || 0
          if (this.timeToExpire <= 0) {
            this.onLogout()
          }
        }.bind(this),
        1000
      )
    },
    closePopup: function () {
      this.setCurrentPopup(null)
      this.clearExpirationPopup()
      clearInterval(this.timer)
    },
    onLogout: function () {
      this.closePopup()
      this.logout()
    },
    refreshSession: function () {
      this.closePopup()
      this.getXCsrfToken()
    }
  },
  created() {
    this.getTimeToExpire()
  }
}



// WEBPACK FOOTER //
// ./src/components/common/session-expiration-modal/session-expiration-modal.js